var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"achievement-gem-image",attrs:{"src":_vm.src,"alt":(_vm.rarity + " achievement"),"title":_vm.rarity}})}
var staticRenderFns = []

export { render, staticRenderFns }